import { render, staticRenderFns } from "./Coachs.vue?vue&type=template&id=ae95c55e&scoped=true"
import script from "./Coachs.vue?vue&type=script&lang=js"
export * from "./Coachs.vue?vue&type=script&lang=js"
import style0 from "./Coachs.vue?vue&type=style&index=0&id=ae95c55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae95c55e",
  null
  
)

export default component.exports